export default __webpack_public_path__ + "static/media/others7.e1cb8493.jpg";